import { createFileRoute } from '@tanstack/react-router'

import CreateRouteForm from '@/features/routes/components/create-route-form'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/dashboard/routes/create')({
  head: () => ({ meta: [{ title: localizedPageTitle('createRoute') }] }),
  component: CreateRoutePage,
})

function CreateRoutePage() {
  useDocumentTitle('createRoute')
  return (
    <div className="mx-auto max-w-2xl space-y-4 2xl:p-8">
      <CreateRouteForm />
    </div>
  )
}
